module.exports = "/_next/static/images/88f0838f1cf8407731c51611f887a743-image-right-lg.jpg";